module.exports = __webpack_public_path__ + "static/gallery-6-bb29d24e0462152879885a1d217faab9.png";